import { Data } from '../Data';

export class CountrySelectorList extends Data {
  static instance: any = null;
  countries: any;
  attributes: any;

  constructor(options: any) {
    super({
      api: '/Organization/Admin/Billing/SupportedCountries',
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options,
    });
  }

  onDataReceived(data: any) {
    this.countries = data.countries;
  }

  static getCountrySelectorList(context: any, search: any) {
    return new Promise((resolve: any, reject) => {
      // Only return the cached instance when it actually has countries loaded. A previous
      // failed/incomplete fetch can leave the singleton with `countries === undefined`,
      // which then permanently empties the dropdown on subsequent mounts (e.g. clicking
      // Edit on the checkout's read-only billing summary). Guard the cache hit so a
      // broken cache forces a fresh fetch instead of poisoning every subsequent mount.
      const cached = CountrySelectorList.instance;
      const hasCachedCountries =
        cached && Array.isArray(cached.countries) && cached.countries.length > 0;
      if (hasCachedCountries && (search === '' || search === null)) resolve(cached, true);
      else
        CountrySelectorList.instance = new CountrySelectorList({
          resolve,
          reject,
          search,
          context,
        });
    });
  }

  findMatch(attr: any) {
    return this.attributes.find((a: any) => a.name === attr);
  }
}
